<template>
  <v-btn
    class="btn-payment ma-0"
    :style="'border-color:' + (borderColor ? borderColor : color)"
    :disabled="disabled"
    avatar
    @click="$emit('click')"
  >
    <div>
      <span
        :style="useTitleColor ? ('color:' + color) : ''"
        class="text-left"
      >
        {{ title }}
      </span>
      <span class="text-right">
        <v-icon
          v-if="icon"
          :style="'color:' + color"
          large
        >
          {{ icon }}
        </v-icon>
        <img
          v-if="image"
          :src="image"
          height="28px"
          class="mr-1"
          alt="image"
        >
      </span>
    </div>
  </v-btn>
</template>

<script>
export default {
  name: 'ActionBtn',

  props: {
    title: { type: String, default: null },
    icon: { type: String, default: null },
    image: { type: String, default: null },
    color: { type: String, default: '#454543' },
    borderColor: { type: String, default: null },
    useTitleColor: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  }
}
</script>
